export enum Group {
  Unknown = 'Unknown',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}

export const convertToGroup = (raw: any): Group => {
  switch (raw) {
    case false:
    case 'false':
    case 0:
    case '0':
    case 'a':
    case 'A':
      return Group.A
    case true:
    case 'true':
    case 1:
    case '1':
    case 'b':
    case 'B':
      return Group.B
    case 2:
    case '2':
    case 'c':
    case 'C':
      return Group.C
    case 3:
    case '3':
    case 'd':
    case 'D':
      return Group.D
    default:
      return Group.Unknown
  }
}
